export default __webpack_public_path__ + "static/media/exploded-view_sprite.d5597e5b.png";